module.exports = "//static.hsappstatic.net/ContentUtils/static-1.45892/img/choiceButtons/icon-size-medium.svg"